import { getOptimizelyInstance } from 'utils/Optimizely';
import { generateUUID } from '@optimizely/js-sdk-utils';
import Experiments from 'types/Experiments';
import Cookies from 'js-cookie';

// trails_controller.rb caches anonymous trail pages for performance reasons so we need to pull this from the cookie
const getOptimizelyUserId = () => Cookies.get('optimizely_user_id');

type ExperimentKey = keyof Experiments;

function activate(experimentKey: 'web_growth_pro_checkout_page_v1'): Experiments['web_growth_pro_checkout_page_v1'];
function activate(experimentKey: 'web_sign_up_on_page_modal_static_map'): Experiments['web_sign_up_on_page_modal_static_map'];
function activate(experimentKey: ExperimentKey, overrideAttributes?: any) {
  return getOptimizelyInstance().activate(experimentKey, getOptimizelyUserId(), overrideAttributes);
}

type EventKey =
  | 'Green Proceed CTA Button Tapped'
  | 'Pro Awareness Click'
  | 'Pro Awareness Seen'
  | 'Pro Conversion Annual'
  | 'Pro Conversion'
  | 'Signup Clicked'
  | 'Signin Success'
  | 'Signup Success'
  | 'Start Trial'
  | 'Promo Conversion Annual'
  | 'Pro Purchase Buy Now Clicked';

function track(eventKey: EventKey): void {
  const event = __AT_DATA__.optimizelySettings.datafile.events.find((event: any) => event.key === eventKey);

  // see https://docs.developers.optimizely.com/optimizely-data/docs/event-api-getting-started
  const data = {
    account_id: __AT_DATA__.optimizelySettings.datafile.accountId,
    anonymize_ip: true,
    enrich_decisions: true,
    visitors: [
      {
        snapshots: [
          {
            events: [
              {
                entity_id: event.id,
                key: eventKey,
                timestamp: Date.now(),
                uuid: generateUUID()
              }
            ]
          }
        ],
        visitor_id: getOptimizelyUserId(),
        attributes: [
          { entity_id: '19356770061', key: 'locale', type: 'custom', value: __AT_DATA__.languageRegionCode },
          { entity_id: '19431290056', key: 'mobileBrowser', type: 'custom', value: __AT_DATA__.mobileBrowser }
          // doesn't seem necessary but going to leave this in here just in case
          // { entity_id: '$opt_bot_filtering', key: '$opt_bot_filtering', type: 'custom', value: false }
        ]
      }
    ]
  };

  navigator.sendBeacon('https://logx.optimizely.com/v1/events', JSON.stringify(data));
}

export { activate, getOptimizelyUserId, track };
